module.exports = __webpack_public_path__ + "img/benefit_cfp-pregame-tailgate.6ccf1674.jpg";